import styles from "./styles.module.scss";

function Slide1({ team }) {

    return (
        <>
            <div className={styles.container}>

                <section className={styles.box}>
                    <div className={styles.text}>
                        {team.description}
                    </div>
                    <div className={styles.name}>
                        {team.nom}
                    </div>
                    <div className={styles.profession}>
                        {team.profession}
                    </div>
                    <div className={styles.circle}>
                    </div>
                    <img src={team.image} alt="profile pic" />
                </section>
            </div>
        </>
    )
}

export default Slide1;